export default __webpack_public_path__ + "static/media/cookie_highcontrast--light.011b912f.svg";